import { render, staticRenderFns } from "./TotalItem.vue?vue&type=template&id=711f54c5&scoped=true&lang=pug&"
import script from "./TotalItem.vue?vue&type=script&lang=js&"
export * from "./TotalItem.vue?vue&type=script&lang=js&"
import style0 from "./TotalItem.vue?vue&type=style&index=0&id=711f54c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f54c5",
  null
  
)

export default component.exports